function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Home Form
 * 
 */
import * as React from 'react';
import ErrorMessage from '../../../components/error-message/ErrorMessage';
import Select from '../../../components/select/Select';
import { Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { application, deleteAll, locality } from '../../../actions';
import { connect } from 'react-redux';
import { API, OPTIONS, STATES, appDomain, stateForDomain, PROD_DOMAIN_PRIMARY, PROD_DOMAIN_SECONDARY, IS_PROD } from '../../../data/Data';
import { portalFetch, setActiveDomain, getActiveDomain } from '../../../utils/portalFetch';
import './HomeForm.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class HomeForm extends React.Component {
  constructor(props) {
    super(props);
    /**
     * handleKeydown
     */
    _defineProperty(this, "handleKeydown", e => {
      // $FlowFixMe
      const {
        key
      } = e;
      const {
        buttonFocus
      } = this.state;
      if (buttonFocus && (key === ' ' || key === 'Enter')) {
        e.preventDefault();
        this.submit(e);
      }
    });
    /**
     * submit form
     */
    _defineProperty(this, "submit", e => {
      e.preventDefault();
      const {
        locality,
        setLocality
      } = this.props;
      if (locality.valid) {
        this.setState({
          submitting: true
        });
        this.post();
        return;
      }

      // validate
      setLocality(locality.value);
    });
    /**
     * Check domain health via GET /.server/trace
     */
    _defineProperty(this, "checkDomainHealth", async domain => {
      const HEALTH_CHECK_TIMEOUT_MS = 5000;
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), HEALTH_CHECK_TIMEOUT_MS);
      try {
        await fetch(`https://${domain}/.server/trace`, {
          mode: 'no-cors',
          signal: controller.signal
        });
        return {
          healthy: true
        };
      } catch (err) {
        return {
          healthy: false
        };
      } finally {
        clearTimeout(timeoutId);
      }
    });
    /**
     * Determine active domain before making requests
     */
    _defineProperty(this, "determineActiveDomain", async bugsnagClient => {
      const activeDomain = getActiveDomain();
      if (activeDomain === PROD_DOMAIN_SECONDARY) {
        return;
      }
      const primaryResult = await this.checkDomainHealth(PROD_DOMAIN_PRIMARY);
      if (!primaryResult.healthy) {
        const secondaryResult = await this.checkDomainHealth(PROD_DOMAIN_SECONDARY);
        if (secondaryResult.healthy) {
          setActiveDomain(PROD_DOMAIN_SECONDARY);
          if (bugsnagClient) {
            bugsnagClient.notify(new Error('Primary domain unreachable, using secondary domain'), event => {
              event.severity = 'info';
              event.addMetadata('domain', {
                primaryDomain: PROD_DOMAIN_PRIMARY,
                secondaryDomain: PROD_DOMAIN_SECONDARY,
                activeDomain: PROD_DOMAIN_SECONDARY
              });
              if (secondaryResult.clientIP) {
                event.addMetadata('network', {
                  clientIP: secondaryResult.clientIP
                });
              }
            });
          }
        }
      }
    });
    /**
     * Post to API
     */
    _defineProperty(this, "post", async () => {
      const {
        cookies,
        locality,
        bugsnagClient
      } = this.props;
      if (IS_PROD) {
        await this.determineActiveDomain(bugsnagClient);
      }
      const data = {
        club_abbreviation: locality.club,
        state: locality.value,
        cookies_agreed: cookies
      };
      const options = {
        ...OPTIONS,
        body: JSON.stringify(data)
      };
      let requestMetadata = {
        request: data
      };
      portalFetch(API, options).then(response => {
        if (response.status >= 400) {
          return response.text().then(responseBody => {
            requestMetadata = {
              request: data,
              response: {
                status: response.status,
                statusText: response.statusText,
                body: responseBody.substring(0, 1000)
              }
            };
            throw new Error(`HTTP status code: ${response.status}`);
          });
        } else {
          return response.json();
        }
      }).then(results => this.success(results)).catch(error => this.error(error, requestMetadata));
    });
    /**
     * Success
     */
    _defineProperty(this, "success", result => {
      const {
        formRef,
        setApplication
      } = this.props;
      if (result.errors && result.message || !result.data) {
        const message = result.message ? result.message : 'No data returned from API';
        const err = new Error(message);
        const metadata = {
          response: {
            status: 200,
            body: JSON.stringify(result).substring(0, 1000)
          }
        };
        this.error(err, metadata);
        return;
      }
      const {
        club,
        created_at,
        id,
        submission_token
      } = result.data;
      const app = {
        club,
        created_at,
        id,
        submission_token,
        referrer: window.location.href
      };
      setApplication(app);
      if (!formRef || !formRef.current || !result) {
        return null;
      }

      // Wait for React to re-render with updated props before submitting
      // This ensures the hidden form fields have the fresh created_at value
      setTimeout(() => {
        formRef.current.submit();
      }, 100);
    });
    /**
     * Post form content to club URL
     */
    _defineProperty(this, "redirect", result => {
      const {
        formRef
      } = this.props;
      if (!formRef || !formRef.current || !result) {
        return null;
      }
      formRef.current.submit();
    });
    /**
     * Error
     */
    _defineProperty(this, "error", (error, metadata) => {
      const {
        bugsnagClient,
        jest,
        locality
      } = this.props;
      if (jest) return null;
      console.warn(error);
      this.setState({
        error: true,
        submitted: false,
        submitting: false
      });
      bugsnagClient.notify(error, event => {
        event.addMetadata('request', {
          url: API,
          state: locality.value,
          club: locality.club,
          ...(metadata?.request && {
            data: metadata.request
          })
        });
        if (metadata?.response) {
          event.addMetadata('response', metadata.response);
        }
        event.addMetadata('ui', {
          userMessage: 'There has been an error starting your application'
        });
      });
    });
    /**
     * buttonFocus
     */
    _defineProperty(this, "buttonFocus", () => {
      const {
        buttonFocus
      } = this.state;
      this.setState({
        buttonFocus: !buttonFocus
      });
    });
    this.state = {
      buttonFocus: false,
      domain: '',
      error: false,
      submitted: false,
      submitting: false
    };
  }
  componentDidMount() {
    const {
      deleteAll,
      setLocality
    } = this.props;
    const state = stateForDomain(window.location.host);

    // Clear application state
    deleteAll();
    if (state) {
      setLocality(state);
    }

    // $FlowFixMe
    document.addEventListener('keydown', this.handleKeydown);
  }
  componentWillUnmount() {
    // $FlowFixMe
    document.removeEventListener('keydown', this.handleKeydown);
  }
  render() {
    const {
      application,
      button,
      content,
      cookies,
      formRef,
      locality,
      setLocality,
      title
    } = this.props;
    const {
      error,
      submitted,
      submitting
    } = this.state;
    const {
      club,
      created_at,
      id,
      submission_token
    } = application;

    // If staying on same domain and submitted then redirect
    if (submitted) {
      return /*#__PURE__*/_jsx(Redirect, {
        to: "/details"
      });
    }
    let {
      host,
      port,
      protocol
    } = window.location;
    const domain = appDomain(host, locality.value);
    port = port ? `:${port}` : '';
    const action = domain ? `${protocol}//${domain}${port}/details` : null;

    // Set the default drop down option
    let select = [...STATES];
    select[0].title = 'Select your state';
    const values = {
      locality
    };
    return /*#__PURE__*/_jsxs("form", {
      className: "HomeForm",
      ref: formRef,
      action: action,
      children: [/*#__PURE__*/_jsx("span", {
        id: "aaa-idp-start"
      }), /*#__PURE__*/_jsxs("div", {
        className: "HomeForm-container",
        children: [/*#__PURE__*/_jsx("h3", {
          children: title
        }), /*#__PURE__*/_jsx("div", {
          className: "content",
          dangerouslySetInnerHTML: {
            __html: content
          }
        }), /*#__PURE__*/_jsxs("div", {
          className: "form-elements",
          children: [/*#__PURE__*/_jsx(Select, {
            errorMessage: "To start your application, please choose a state.",
            options: select,
            section: "home-form",
            name: "locality",
            label: "Select your state"
            // $FlowFixMe
            ,
            values: values,
            handleChange: setLocality,
            onBlur: setLocality
          }), /*#__PURE__*/_jsx("button", {
            id: "what-you-need",
            onClick: this.submit,
            onFocus: this.buttonFocus,
            onBlur: this.buttonFocus,
            children: submitting ? /*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: "spinner",
              spin: true
            }) : button
          })]
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "cookies",
          value: cookies
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "id",
          value: id
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "token",
          value: submission_token
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "club_id",
          value: club.id
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "club_name",
          value: club.name
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "club_abbreviation",
          value: club.abbreviation
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "created_at",
          value: created_at
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "referrer",
          value: window.location.href
        }), /*#__PURE__*/_jsx(ErrorMessage, {
          message: "There has been an error starting your application",
          error: error
        })]
      })]
    });
  }
}
_defineProperty(HomeForm, "defaultProps", {
  application: {
    club: {
      id: 0,
      name: '',
      abbreviation: ''
    },
    id: 0,
    submission_token: ''
  },
  button: 'Start your IDP Application',
  content: 'Please select your state to process your IDP. By selecting your state you consent to providing your personal information to the AAA and their sales agent in order to process your IDP.<br /><br /><strong>Please note:</strong> You have 24 hours to complete your application once started.',
  cookies: false,
  deleteAll: () => null,
  jest: false,
  locality: {
    error: false,
    required: true,
    valid: null,
    value: ''
  },
  setApplication: () => null,
  setLocality: () => null,
  title: 'Start your application'
});
const mapStateToProps = ({
  application,
  cookies,
  locality
}) => {
  return {
    application,
    cookies,
    locality
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deleteAll: () => {
      dispatch(deleteAll());
    },
    setApplication: value => {
      dispatch(application(value));
    },
    setLocality: value => {
      dispatch(locality(value));
    }
  };
};
const VisibleHomeForm = connect(mapStateToProps, mapDispatchToProps)(HomeForm);
export default VisibleHomeForm;